import { managedAddEventListener } from "./01-stacked-events.js";
import { closeToasts } from "./toast.js";

// `document.body` is undefined until...
managedAddEventListener(document, "DOMContentLoaded", function () {
  const htmxBeforeSwap = (event) => {
    const status = event.detail.xhr.status;
    if (status >= 400 && status <= 499) {
      // allow responses to swap
      // an alternative would be to update server to return non 4xx
      event.detail.shouldSwap = true;
      event.detail.isError = false;
    }
  };

  closeToasts();
  handleQRs();
  initSliderPagination();

  managedAddEventListener(document.body, "htmx:beforeSwap", htmxBeforeSwap);
  managedAddEventListener(document.body, "htmx:afterSwap", () => {
    handleQRs();
    initSliderPagination();
  });
});

const handleQRs = () => {
  // redemption qrs
  btnRedeemEvent = document.getElementById("btn-redeem-event");
  qrRedeemEvent = document.getElementById("qr-redeem-event");

  btnRedeemSurvey = document.getElementById("btn-redeem-survey");
  qrRedeemSurvey = document.getElementById("qr-redeem-survey");

  // should only show one QR at a time
  if (btnRedeemEvent != null) {
    managedAddEventListener(btnRedeemEvent, "click", function (event) {
      event.preventDefault();

      btnRedeemEvent.classList.add("hidden");
      qrRedeemEvent.classList.remove("hidden");

      if (btnRedeemSurvey != null) {
        btnRedeemSurvey.classList.remove("hidden");
        qrRedeemSurvey.classList.add("hidden");
      }
    });
  }
  if (btnRedeemSurvey != null) {
    managedAddEventListener(btnRedeemSurvey, "click", function (event) {
      event.preventDefault();

      btnRedeemSurvey.classList.add("hidden");
      qrRedeemSurvey.classList.remove("hidden");

      if (btnRedeemEvent != null) {
        btnRedeemEvent.classList.remove("hidden");
        qrRedeemEvent.classList.add("hidden");
      }
    });
  }
};

const initSliderPagination = () => {
  const sliders = document.querySelectorAll('[data-slider="items"]');

  sliders.forEach((slider) => {
    const slides = slider.querySelectorAll('[data-slider-slide="items"]');
    const dots = slider.parentElement?.querySelectorAll("[data-slider-dot]");
    if (!slides || slides.length === 0 || !dots || dots.length === 0) {
      return;
    }

    const setActiveDot = (activeIndex) => {
      dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.remove("bg-grey-500");
          dot.classList.add("bg-white");
          return;
        }
        dot.classList.remove("bg-white");
        dot.classList.add("bg-grey-500");
      });
    };

    const updateActiveByScroll = () => {
      const viewportCenter = slider.scrollLeft + slider.clientWidth / 2;
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      slides.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
        const distance = Math.abs(slideCenter - viewportCenter);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      setActiveDot(nearestIndex);
    };

    let rafPending = false;
    const onScroll = () => {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(() => {
        updateActiveByScroll();
        rafPending = false;
      });
    };

    updateActiveByScroll();
    managedAddEventListener(slider, "scroll", onScroll);
    managedAddEventListener(window, "resize", updateActiveByScroll);
  });
};
